import { render } from "./NotificationSurvey.vue?vue&type=template&id=2c25da1d&scoped=true&ts=true"
import script from "./NotificationSurvey.vue?vue&type=script&lang=ts"
export * from "./NotificationSurvey.vue?vue&type=script&lang=ts"

import "./NotificationSurvey.vue?vue&type=style&index=0&id=2c25da1d&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c25da1d"]])

export default __exports__